module.exports = __webpack_public_path__ + "static/media/3.a2a4b395.jpg";